import { useState, useEffect, useRef } from "react";
import { speakText, cancelSpeech } from "../tts";

export default function useSpeechBubble(founders, currentIndex, isAnimating) {
  const [speechBubble, setSpeechBubble] = useState(null);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const speechTimerRef = useRef(null);
  const quoteIndexRef = useRef(0);

  useEffect(() => {
    if (isAnimating) {
      setSpeechBubble(null);
      setIsSpeaking(false);
      clearTimeout(speechTimerRef.current);
      cancelSpeech();
      return;
    }

    const founder = founders[currentIndex % founders.length];
    quoteIndexRef.current = 0;
    let cancelled = false;

    const showBubble = () => {
      if (cancelled) return;
      const qi = quoteIndexRef.current % founder.quotes.length;
      const text = founder.quotes[qi];
      quoteIndexRef.current = qi + 1;

      setSpeechBubble(text);
      speakText(
        text,
        founder.id,
        () => setIsSpeaking(true),
        () => {
          // Speech finished naturally — hide bubble, then show next after a gap
          if (cancelled) return;
          setIsSpeaking(false);
          setSpeechBubble(null);
          speechTimerRef.current = setTimeout(showBubble, 2000);
        }
      );
    };

    speechTimerRef.current = setTimeout(showBubble, 1500);

    return () => {
      cancelled = true;
      clearTimeout(speechTimerRef.current);
      cancelSpeech();
    };
  }, [currentIndex, isAnimating, founders]);

  return { speechBubble, isSpeaking };
}
